<template>
  <div>
    <section id="sec01" class="mt-3" v-if="edit == false">
      <v-card color="#FEF9E7">
        <v-layout class="mt-2">
          <v-flex xs2 class="py-0 pr-0">
            <div class="d-flex flex-icon-address-card">
              <v-icon large color="black">place</v-icon>
            </div>
          </v-flex>
          <v-flex xs8>
            <div class="text-address">
              <span style="font-size:15px;">
                <strong>Name:</strong>
                {{info.user_address_name}}
                <br />
                <strong>Address :</strong>
                {{info.user_address_text}}
                <br />
                <strong>District :</strong>
                {{info.user_address_district}}
                <br />
                <strong>Sub district :</strong>
                {{info.user_address_sub_district}}
                <br />
                <strong>Province :</strong>
                {{info.user_address_province}}
                <br />
                <strong>Postal code :</strong>
                {{info.user_address_zipcode}}
              </span>
            </div>
          </v-flex>
          <v-flex xs2>
            <v-btn icon class="edit-btn" :disabled="isEditCustomer" @click="toEdit()">
              <v-icon>edit</v-icon>
            </v-btn>
            <span class="default-text">{{isDefault}}</span>
            <v-btn icon class="delete-btn" :disabled="isEditCustomer" @click="toDelete()">
              <v-icon>delete</v-icon>
            </v-btn>

            <v-btn
              color="#D6DBDF"
              class="set-default-btn"
              v-if="info.user_address_default == false"
              @click="setAsDefault()"
              :disabled="isEditCustomer"
            >set as default</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </section>
    <section id="sec02" class="mt-3" v-if="edit == true">
      <h1 style="font-size:22px;">Edit Address</h1>
      <v-card color="#FEF9E7">
        <v-form ref="formEdit" v-model="valid" lazy-validation>
          <v-layout row class="px-3">
            <v-flex>
              <v-text-field
                class="mt-2"
                v-model="info.user_address_name"
                label="Address name"
                :rules="[validation.required]"
              ></v-text-field>
              <v-text-field
                v-model="info.user_address_text"
                label="Address"
                :rules="[validation.required]"
              ></v-text-field>
              <v-layout row>
                <v-flex xs6 class="mr-2">
                  <v-select
                    :items="provinceItems"
                    v-on:change="onChangeProvince"
                    v-model="info.user_address_province"
                    item-value="province_name_th"
                    item-text="province_name_th"
                    label="Province"
                    :rules="[validation.required]"
                  ></v-select>
                </v-flex>
                <v-flex xs6 class="ml-2">
                  <v-select
                    :items="districtItems"
                    v-on:change="onChangeDistrict"
                    v-model="info.user_address_district"
                    item-text="district_name_th"
                    item-value="district_name_th"
                    label="District"
                    :rules="[validation.required]"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 class="mr-2">
                  <v-select
                    :items="subDistrictItems"
                    v-model="info.user_address_sub_district"
                    item-text="sub_district_name_th"
                    label="Sub district"
                    :rules="[validation.required]"
                  ></v-select>
                </v-flex>
                <v-flex xs6 class="ml-2">
                  <v-select
                    :items="postcodeItems"
                    v-model="info.user_address_zipcode"
                    item-text="zipcode_code"
                    label="Post Code"
                    :rules="[validation.required]"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-textarea
                name="note"
                v-model="info.user_address_note"
                label="Place Note"
                value
                hint="Hint text"
                rows="1"
              ></v-textarea>
              <v-layout row>
                <v-flex xs6 class="mr-2">
                  <v-text-field
                    :rules="[rules.required,rules.onlyDouble]"
                    label="latitude"
                    v-model="info.user_address_lat"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="ml-2">
                  <v-text-field
                    :rules="[rules.required,rules.onlyDouble]"
                    label="longitude"
                    v-model="info.user_address_long"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-btn @click="change_location ++">Update map</v-btn>
              <v-card height="auto" width="auto" color="grey">
                <GoogleMap
                  :latitude="parseFloat(info.user_address_lat)"
                  :longitude="parseFloat(info.user_address_long)"
                  :change="change_location"
                  :height="400"
                  :zoom="15"
                  :mapType="'all'"
                  :draggable="true"
                  @draged="getDragLocation($event)"
                ></GoogleMap>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="cancelEdit()">Cancel</v-btn>
          <v-btn color="green" :disabled="isEditCustomer" flat @click="save()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["info", "selectedCustomer"],
  data() {
    return {
      rules: {
        onlyDouble: value => {
          const pattern = /^-?([0-9]?[0-9]?[0-9]?[0-9]|[0-9]0)\.{1}\d{1,100}$/;
          return pattern.test(value) || "Invalid";
        },
        required: value => !!value || "Required."
      },
      change_location: 0,
      districtItems: [],
      postcodeItems: [],
      provinceItems: [],
      subDistrictItems: [],
      originalData: null,
      edit: false,
      province: null,
      valid: true,
      address: "",
      validation: {
        required: value => !!value || "Required."
      }
    };
  },
  computed: {
    ...mapState({
      customerData: state => state.fetchCustomerBack.customerData
    }),
    ...mapGetters(["isEditCustomer"]),
    isDefault() {
      if (this.info.user_address_default == true) {
        return "[Default]";
      } else {
        return null;
      }
    }
  },
  async created() {
    this.provinceItems = await this.$store.dispatch(
      "fetchCustomerBack/getProvinceEdit"
    );
  },
  methods: {
    getDragLocation(val) {
      this.info.user_address_lat = val.lat;
      this.info.user_address_long = val.lng;
    },
    async setAsDefault() {
      let index = this.selectedCustomer.user_address.indexOf(this.info);
      for (let key in this.selectedCustomer.user_address) {
        this.selectedCustomer.user_address[key].user_address_default = false;
      }
      this.selectedCustomer.user_address[index].user_address_default = true;
      for (let key in this.selectedCustomer.user_address) {
        if (
          this.selectedCustomer.user_address[key].user_address_default == true
        ) {
          let sendData = {
            user_address_default: 1,
            user_address_id: this.selectedCustomer.user_address[key]
              .user_address_id,
            user_address_user: this.selectedCustomer.user_id
          };
          await this.$store.dispatch(
            "fetchCustomerBack/setAsDefault",
            sendData
          );
        } else if (
          this.selectedCustomer.user_address[key].user_address_default == false
        ) {
          let sendData = {
            user_address_default: 0,
            user_address_id: this.selectedCustomer.user_address[key]
              .user_address_id,
            user_address_user: this.selectedCustomer.user_id
          };
          await this.$store.dispatch(
            "fetchCustomerBack/setAsDefault",
            sendData
          );
        }
      }
    },
    toDelete() {
      let index_customer = this.customerData.indexOf(this.selectedCustomer);
      let send_data = {
        index_customer: index_customer,
        address_info: this.info
      };

      confirm("Are you sure you want to delete this address?") &&
        this.$store.dispatch(
          "fetchCustomerBack/deleteCustomerAddress",
          send_data
        );
    },
    async onChangeDistrict() {
      let district_id = null;
      for (let key in this.districtItems) {
        if (
          this.districtItems[key].district_name_th ==
          this.info.user_address_district
        ) {
          district_id = this.districtItems[key].district_id;
        }
      }
      this.info.user_address_sub_district = null;
      this.info.user_address_zipcode = null;
      this.subDistrictItems = [];
      this.postcodeItems = [];
      this.subDistrictItems = await this.$store.dispatch(
        "fetchCustomerBack/getSubDistrictEdit",
        district_id
      );

      this.postcodeItems = await this.$store.dispatch(
        "fetchCustomerBack/getZipCodeEdit",
        district_id
      );
    },
    async initDistrict() {
      let district_id = null;
      for (let key in this.districtItems) {
        if (
          this.districtItems[key].district_name_th ==
          this.info.user_address_district
        ) {
          district_id = this.districtItems[key].district_id;
        }
      }
      this.subDistrictItems = [];
      this.postcodeItems = [];
      this.subDistrictItems = await this.$store.dispatch(
        "fetchCustomerBack/getSubDistrictEdit",
        district_id
      );

      this.postcodeItems = await this.$store.dispatch(
        "fetchCustomerBack/getZipCodeEdit",
        district_id
      );
    },
    async onChangeProvince() {
      let province_id = null;
      for (let key in this.provinceItems) {
        if (
          this.provinceItems[key].province_name_th ==
          this.info.user_address_province
        ) {
          province_id = this.provinceItems[key].province_id;
        }
      }
      this.info.user_address_district = null;
      this.info.user_address_sub_district = null;
      this.info.user_address_zipcode = null;
      this.subDistrictItems = [];
      this.postcodeItems = [];
      this.districtItems = [];
      this.districtItems = await this.$store.dispatch(
        "fetchCustomerBack/getDistrictEdit",
        province_id
      );
    },
    async initProvince() {
      let province_id = null;
      for (let key in this.provinceItems) {
        if (
          this.provinceItems[key].province_name_th ==
          this.info.user_address_province
        ) {
          province_id = this.provinceItems[key].province_id;
        }
      }
      this.subDistrictItems = [];
      this.postcodeItems = [];
      this.districtItems = [];
      this.districtItems = await this.$store.dispatch(
        "fetchCustomerBack/getDistrictEdit",
        province_id
      );
    },
    cancelEdit() {
      Object.assign(this.info, this.originalData);
      this.edit = !this.edit;
      this.originalData = null;
    },
    async toEdit() {
      this.originalData = Object.assign({}, this.info);
      this.edit = !this.edit;
      await this.initProvince();
      this.initDistrict();
    },
    async save() {
      if (this.$refs.formEdit.validate()) {
        let user_address_default = null;
        if (this.info.user_address_default == true) {
          user_address_default = 1;
        } else {
          user_address_default = 0;
        }
        let user_address_sub_district = null;
        for (let key in this.subDistrictItems) {
          if (
            this.subDistrictItems[key].sub_district_name_th ==
            this.info.user_address_sub_district
          ) {
            user_address_sub_district = this.subDistrictItems[key]
              .sub_district_id;
          }
        }

        let user_address_district = null;
        for (let key in this.districtItems) {
          if (
            this.districtItems[key].district_name_th ==
            this.info.user_address_district
          ) {
            user_address_district = this.districtItems[key].district_id;
          }
        }

        let user_address_province = null;
        for (let key in this.provinceItems) {
          if (
            this.provinceItems[key].province_name_th ==
            this.info.user_address_province
          ) {
            user_address_province = this.provinceItems[key].province_id;
          }
        }

        let user_address_zipcode = null;
        for (let key in this.postcodeItems) {
          if (
            this.postcodeItems[key].zipcode_code ==
            this.info.user_address_zipcode
          ) {
            user_address_zipcode = this.postcodeItems[key].zipcode_id;
          }
        }

        const sendInfo = {
          user_address_id: this.info.user_address_id,
          user_address_default: user_address_default,
          user_address_note:
            this.info.user_address_note == ""
              ? null
              : this.info.user_address_note,
          user_address_text: this.info.user_address_text,
          user_address_lat: parseFloat(this.info.user_address_lat),
          user_address_long: parseFloat(this.info.user_address_long),
          user_address_user: this.selectedCustomer.user_id,
          user_address_sub_district: user_address_sub_district,
          user_address_district: user_address_district,
          user_address_province: user_address_province,
          user_address_zipcode: user_address_zipcode,
          user_address_name: this.info.user_address_name
        };
        this.edit = !this.edit;
        let isSuccess = await this.$store.dispatch(
          "fetchCustomerBack/editCustomerAddress",
          sendInfo
        );
        if (isSuccess == "error") {
          Object.assign(this.info, this.originalData);
        }
        this.clear();
      }
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.edit-btn {
  position: absolute;
  right: 35px;
  top: 1px;
}

.delete-btn {
  position: absolute;
  right: 0px;
  top: 1px;
}

.default-text {
  color: red;
  position: absolute;
  right: 15px;
  bottom: 15px;
}

.set-default-btn {
  position: absolute;
  right: 8px;
  bottom: 16px;
}

.text-address {
  padding: 16px;
}

.flex-icon-address-card {
  background-color: #ffd600;
  height: 100%;
  border-radius: 3px 0px 0px 3px;
}
</style>
